/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/prefer-for-of */
import { ChangeDetectorRef, Component, signal, ViewEncapsulation } from '@angular/core';
import { ActivationEnd, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Account } from 'app/_helper/user/user.types';
import { UserService } from 'app/_services/user.service';
import { MenuModel } from 'app/_models/menu.model';
import { MenuService } from 'app/_services/menu.service';
import { HttpRequestCancelService } from 'app/_services/httprequestcancel.service';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { UserComponent } from 'app/user/user.component';
import { SearchComponent } from 'app/_commoncomponent/search/search.component';
import { CommonFileModules } from 'app/_commoncomponent/_commonmodule.module';
import AutoRefresh, { AutoRefreshTarget } from 'app/_helper/autorefresh';
import { NavigationService } from 'app/_services/navigation.service';

@Component({
  selector: 'classy-layout',
  styleUrls: ['./classy.component.less'],
  templateUrl: './classy.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [FuseFullscreenComponent, FuseLoadingBarComponent, FuseVerticalNavigationComponent, SearchComponent, UserComponent, CommonFileModules, RouterOutlet],
})
export class ClassyLayoutComponent implements AutoRefreshTarget {
  isScreenSmall: boolean;
  vertical: any;
  isStaticMenu = false;
  //user: User;
  user: Account;
  _menu: MenuModel[];
  selectedData = null;
  $hideSearch = signal(false);
  brand = '';
  appitems: FuseNavigationItem[] = [];
  expandCollapseStatus: string = null;
  private readonly autoRefresh: AutoRefresh;

  //example
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private _menuService: MenuService,
    private _navigationService: NavigationService,
    private _userService: UserService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _fuseNavigationService: FuseNavigationService,
    private httpCancelService: HttpRequestCancelService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    this.autoRefresh = new AutoRefresh(this);
  }
  onAutoRefresh(): void {
    this._navigationService.getApprovals();
  }

  public branding(): string {
    let brand = 'esayworkmobilecouk';
    brand = window.location.hostname.replace(/\./g, '');
    return brand;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  async ngOnInit() {
    this.brand = this.branding();
    this._menuService.menu.pipe(takeUntil(this._unsubscribeAll)).subscribe((v) => {
      // Always assign a new reference to vertical and its children
      this.vertical = [{ ...v.root, children: [...(v.root.children || []).map((c) => ({ ...c }))] }];
      // console.log(this.vertical);
      this._changeDetectorRef.markForCheck();
      if (v.root.title == 'Static Menu') {
        this.isStaticMenu = true;
        // this.autoRefresh.start(10000);
      }
    });

    // Subscribe to the user service
    this.user = await this._userService.user$;
    // .pipe(takeUntil(this._unsubscribeAll)).subscribe((user: User) => {
    // this.user = user;
    // });

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$.pipe(takeUntil(this._unsubscribeAll)).subscribe(({ matchingAliases }) => {
      // Check if the screen is small
      this.isScreenSmall = !matchingAliases.includes('md');
      if (this.isScreenSmall) {
        this._fuseMediaWatcherService.navigationChange.next(true);
      } else {
        this._fuseMediaWatcherService.navigationChange.next(false);
      }
    });
    if (
      this._router.url.includes('schedule') ||
      this._router.url.includes('questionnairebuilder') ||
      this._router.url.includes('job-assignment') ||
      this._router.url.includes('jobmapview') ||
      this._router.url.includes('lone-worker/configuration') ||
      this._router.url.includes('lone-worker/reports') ||
      this._router.url.includes('track-worker') ||
      this._router.url.includes('tracking')
    ) {
      this.$hideSearch.set(true);
    } else {
      this.$hideSearch.set(false);
    }
    this._router.events.subscribe((event) => {
    this.updateHeaderVisibility(this._router.url);
    queueMicrotask(() => this.updateHeaderVisibility(this._router.url));
    });
    this._router.events.pipe(takeUntil(this._unsubscribeAll)).subscribe((event) => {
      if (event instanceof ActivationEnd && !this.httpCancelService.sameComponent) {
        this.httpCancelService.cancelPendingRequests();
      }
      if (event instanceof NavigationEnd) {
        if (
          this._router.url.includes('schedule') ||
          this._router.url.includes('questionnairebuilder') ||
          this._router.url.includes('job-assignment') ||
          this._router.url.includes('jobmapview') ||
          this._router.url.includes('lone-worker/configuration') ||
          this._router.url.includes('lone-worker/reports') ||
          this._router.url.includes('track-worker') ||
          this._router.url.includes('tracking')
        ) {
          this.$hideSearch.set(true);
        } else {
          this.$hideSearch.set(false);
        }
        this.ngAfterViewInit();
        this.updateHeaderVisibility(event.urlAfterRedirects);
      }
    });
    if (this.isStaticMenu) {
    }
  }

  ngAfterViewInit(): void {
    let isApprovalPage = this._router.url.includes('approval') ? true : false;
    if (!isApprovalPage) this.autoRefresh.enabled = true;
    else this.autoRefresh.enabled = false;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.autoRefresh.stop();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
    this._fuseMediaWatcherService.navigationChange.next(true);
  }
  toggleNavigation1(name: string): void {
    // Get the navigation
    const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
    this._fuseMediaWatcherService.navigationChange.next(false);
  }
  setExpandCollapseStatus(type) {
    this.expandCollapseStatus = type;
  }

  getClass(item) {
    return {
      [item.faIcon]: true,
    };
  }

  private updateHeaderVisibility(url: string): void {
    const normalizedUrl = (url || '').split('?')[0].split('#')[0];
    const urlPath = normalizedUrl.startsWith('/') ? normalizedUrl : `/${normalizedUrl}`;
    const segments = urlPath.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
    const isCrmRoute = segments[0] === 'crm';
    const isCrmListRoute = isCrmRoute && segments.length === 2 && (segments[1] === 'customers' || segments[1] === 'contacts');
    this.$hideSearch.set(
        (isCrmRoute && !isCrmListRoute) ||
        urlPath.includes('schedule') ||
        urlPath.includes('questionnairebuilder') ||
        urlPath.includes('job-assignment') ||
        urlPath.includes('jobmapview') ||
        urlPath.includes('lone-worker/configuration'),
    );
  }

  selectedItem(selectedData) {
    this.selectedData = selectedData;
    switch (selectedData.operation) {
      case 'OPENFORM': {
        this._router.navigate(['/forms/' + selectedData.link + '/completedrecords']);
        break;
      }
      case 'OPENCATALOGUE': {
        this._router.navigate(['/catalogues/' + selectedData.link + '/completedrecords']);
        break;
      }
      /*   case 'OPENBUILDER': {
        this._router.navigate(['/forms/' + selectedData.link + '/questionbuilder']);
        break;
      }
        */
      case 'OPENFORMSLIST':
        this._router.navigate([selectedData.link]);
        break;
      case 'OPENJOB': {
        this._router.navigate([selectedData.link]);
        break;
      } //OPENNOTIFICATIONHISTORY
      case 'OPENNOTIFICATIONHISTORY': {
        this._router.navigate([selectedData.link]);
        break;
      } //OPENJOBCREATE
      // case 'OPENJOBCREATE': {
      //   this._router.navigate([selectedData.link]);
      //   //this._router.navigate(['/jobs/view/'+selectedData.link]);
      //   break;
      // }
      case 'OPENJOBLIST': {
        this._router.navigate([selectedData.link]);
        //this._router.navigate(['/jobs/view/'+selectedData.link]);
        break;
      }
      case 'OPENMEDIAMANAGEMENT': {
        this._router.navigate([selectedData.link]);
        //this._router.navigate(['/jobs/view/'+selectedData.link]);
        break;
      }
      case 'OPENREPORT': {
        //this._router.navigate([selectedData.link]);
        this._router.navigate(['/reports/' + selectedData.link]);
        break;
      }
      case 'OPENEXTERNALWEBPAGE': {
        this._router.navigate(['/external/' + selectedData.link]);
        break;
      }
      case 'OPENTRACKWORKER':
      case 'OPENLONEWORKERTRACKING':
      case 'OPENLONEWORKERREPORTS': {
        this._router.navigate([selectedData.link]);
        break;
      }
      default: {
        this._router.navigate(['/forms/view/' + selectedData.link]);
      }
    }
  }
}
